import React from 'react';
import PropTypes from 'prop-types';

export const PersonalizedSearchLinkTitle = props => {
  const { query } = props;

  return (
    <span className="d-flex text-cool-gray-30">
      <b>search&nbsp;</b>
      <span className="query-text text-start fw-normal">&quot;{query}&quot;</span>
    </span>
  );
};

PersonalizedSearchLinkTitle.propTypes = {
  query: PropTypes.string,
};

PersonalizedSearchLinkTitle.defaultProps = {
  query: '',
};
